module.exports = __webpack_public_path__ + "static/media/C-100HD_CrossSection.001a76f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/C-100HD_CrossSection.png
// module id = 482
// module chunks = 0